import DangerousOutlinedIcon from "@mui/icons-material/DangerousOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EmailIcon from "@mui/icons-material/Email";
import WalletSymbols from "./WalletSymbols";
import { KeyboardArrowRightOutlined } from "@mui/icons-material";

export const logo =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/logo.svg";
export const qrLogo =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/qr-logo.svg";
export const logoWhite =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/logo-white.svg";
export const line =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/line.svg";
export const fill =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/Fill.svg";
export const rotationIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/3d_rotation_icon.svg";
export const sentIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/sent.svg";
export const receiveIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/receive.svg";
export const bitCoinSymbol =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/BitCoin.svg";
export const defaultUser =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/default-user.svg";
export const getStartedBgImage =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/get-started-bgimage.svg";
export const checkEmail =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/check-email.svg";
export const speedPreloader =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/speed-preloader.gif";
export const attentionIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/attention-icon.svg";
export const timerIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/timer-icon.svg";
export const personCancel =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/person-cancel.svg";
export const adminPanelSettings =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/admin-panel-settings.svg";
export const taskAlt =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/task-alt.svg";
export const logoWithName =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/App-Marketplace.svg";
export const fillGrey =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/fill-gray.svg";
export const bitCoinGrey =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/bitcoin-gray.svg";
export const noPendingTransactionIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/no-pending-confirmation-icon.svg";
export const hourGlass =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/pending-transaction-icon.svg";
export const speedLogo =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/speed-logo.svg";
export const googleIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/google-icon.svg";
export const appleIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/apple-icon.svg";
export const pendingConfirmationIconNew =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/pending-confirmation.svg";
export const ethereumIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/ethereum-icon-svg.svg";
export const welcomeToSpeedIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/welcome-to-speed-icon.svg";
export const maintenanceImage =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/maintenance.svg";
export const calenderClockIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/calendar-clock-icon.svg";
export const usdtLightningIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/USDT-L.png";
export const walletBackGroundImage =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/asset-card-background-layer.png";
export const hourGlassOrange =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/hour-glass-orange.svg";
export const createLnAddressIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/create-ln-address-icon.svg";
export const tronIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/tron-icon.svg";
export const promoCodeIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/promo-code-icon.svg";
export const checkCircle =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/check-circle.svg";
export const couponCodeIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/coupon-code-icon.svg";
export const couponCodeIconGrey =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/coupon-code-icon-grey.svg";
export const checkCircleCurved =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/check-circle-curved.svg";
export const twoFAIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/2fa-icon.svg";
export const swapIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/swap-icon.svg";
export const usdcSymbol =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/usdc-symbol.svg";
export const loaderSpinner =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/loader-spinner";
export const createLnAddressIconUSDT =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/create-ln-address-icon-usdt.svg";
export const createLnAddressIconUSDC =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/create-ln-address-icon-usdc.svg";
export const usdcLightningIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/usdc-lightning-icon.svg";
export const categoryBackgroundImage =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/category-card-background-layer.svg";
export const shareIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/share-icon.svg";
export const gridBackgroundLayout =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/collection-background.png";
export const loaderBackgroundLayer =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/loader-background-layer.png";
export const loaderImg =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/loader-img.svg";
export const noMiniAppFoundImg =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/no-mini-app-found-img.svg";
export const deleteIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/delete-icon.svg";
export const privacyPolicyIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/privacy-policy-icon.svg";
export const termsOfUseIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/terms-of-use-icon.svg";
export const contactSupportIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/contact-support-icon.svg";
export const dollarLimitIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/dollar-limit-icon.svg";
export const googlePlayBadge =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/google-play-badge.svg";
export const appStoreBadge =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/app-store-badge.svg";
export const noDataFoundIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/no-data-found.svg";
export const failedIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/failed.svg";
export const timerIconGrey =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/timer-icon-grey.svg";
export const contactIconGrey =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/contacts-icon-grey.svg";
export const authAppIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/auth-app-icon.svg";
export const smsAuthIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/phone-icon.svg";
export const smsIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/sms-icon.svg";
export const walletIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/wallet-icon.svg";
export const walletIconBlue =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/wallet-blue-icon.svg";
export const walletIconFill =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/wallet-icon-fill.svg";
export const appIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/app-icon.svg";
export const appIconFill =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/app-icon-fill.svg";
export const historyIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/history-icon.svg";
export const historyIconFill =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/history-icon-fill.svg";
export const settingsIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/settings-icon.svg";
export const settingsIconFill =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/settings-icon-fill.svg";
export const sendIconUrl =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/qr-scan-icon.svg";
export const verifyMobileIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/verify-mobile-icon.svg";
export const editIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/edit-icon.svg";
export const copyIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/copy-icon.svg";
export const currencyIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/currency-icon.svg";
export const profileIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/profile-icon.svg";
export const accountIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/account-icon.svg";
export const contactIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/contacts-blue-icon.svg";
export const limitIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/limit-icon.svg";
export const changePasswordIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/change-password-icon.svg";
export const twoStepVerificationIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/key-icon.svg";
export const applyPromocodeIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/apply-promo-code-icon.svg";
export const logoutIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/logout-icon.svg";
export const accountNameIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/account-name-icon.svg";
export const accountStatusIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/account-status-icon.svg";
export const closeAccountIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/close-account-icon.svg";
export const noImageIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/no-image-icon.svg";
export const solanaIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/solana-icon.svg";
export const editIconGrey =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/edit-icon-grey.svg";
export const logoutIconBlue =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/logout_icon-blue.svg";
export const verifiedPlanBg =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/verified-plan-bg.png";
export const premiumPlanBg =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/premium-plan-bg.png";
export const ggcIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/ggc-icon.svg";
export const usdIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/usd-icon.svg";
export const downloadStatementIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/app/download-statement-icon.svg";
export const tonIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/ton-icon.svg";
export const shieldLockIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/shield-lock.svg";
export const xautIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/xaut-icon.svg";
export const usdtIcon =
  process.env.REACT_APP_IMAGE_ICON_S3_URL + "/chrome-wallet/usdt-icon.svg";
export const applyPromoCode =
  process.env.REACT_APP_IMAGE_ICON_S3_URL +
  "/chrome-wallet/apply-promo-code.gif";

const settingsIconsCss = {
  color: "#2A67FF",
};

export const buttonIcons = {
  receiveIcon: (
    <WalletSymbols
      symbol="expand_circle_down"
      sx={{ height: "24px", width: "24px" }}
    />
  ),
  sendIcon: <img src={sendIconUrl} height={24} width={24} alt="send-icon" />,
  filter: (
    <FilterAltOutlinedIcon
      sx={{ height: "24px", width: "24px", color: "#2A67FF" }}
    />
  ),
  eyeIcon: (
    <VisibilityIcon sx={{ height: "18px", width: "18px", color: "#2A67FF" }} />
  ),
  google: <img src={googleIcon} height={20} width={20} alt="google-icon" />,
  apple: <img src={appleIcon} height={20} width={20} alt="apple-icon" />,
  emailIcon: <EmailIcon />,
  swapIcon: (
    <WalletSymbols symbol="swap_horiz" sx={{ height: "24px", width: "24px" }} />
  ),
  KeyboardArrowRightOutlined: (
    <KeyboardArrowRightOutlined
      sx={{
        height: "24px",
        width: "24px",
        color: "#2A67FF",
      }}
    />
  ),
};

export const transactionIcons = {
  payment: <img src={receiveIcon} height={24} width={24} alt="receive-icon" />,
  withdraw: <img src={sentIcon} height={24} width={24} alt="sent-icon" />,
  unconfirmed: (
    <img src={hourGlass} height={24} width={24} alt="hour-glass-icon" />
  ),
};

export const errorIcons = {
  invalid: (
    <ErrorOutlineIcon
      sx={{ height: "54px", width: "54px", color: "#D88A2C" }}
    />
  ),
  fail: (
    <DangerousOutlinedIcon
      sx={{ height: "40px", width: "40px", color: "#FD371E" }}
    />
  ),
  timer: <img src={timerIcon} height="54px" width="54px" alt="timer-icon" />,
};

export const settingsIcons = {
  currency: <WalletSymbols sx={settingsIconsCss} symbol="price_change" />,
  security: <WalletSymbols sx={settingsIconsCss} symbol="verified_user" />,
  advSettings: <WalletSymbols sx={settingsIconsCss} symbol="settings" />,
  account: <WalletSymbols sx={settingsIconsCss} symbol="person" />,
  removeAccount: <WalletSymbols sx={settingsIconsCss} symbol="delete" />,
  changePassword: <WalletSymbols sx={settingsIconsCss} symbol="lock" />,
  logout: <WalletSymbols sx={settingsIconsCss} symbol="exit_to_app" />,
  accountStatus: <WalletSymbols sx={settingsIconsCss} symbol="shield_person" />,
  profile: <WalletSymbols sx={settingsIconsCss} symbol="person" />,
  applyPromo: (
    <WalletSymbols sx={settingsIconsCss} symbol="confirmation_number" />
  ),
  keyIcon: <WalletSymbols sx={settingsIconsCss} symbol="key" />,
  contacts: <img src={contactIcon} height={24} alt="contact-icon" width={24} />,
  limit: <img src={dollarLimitIcon} height={24} alt="limit-icon" width={24} />,
};

export const searchbarIcons = {
  dashboard: <GridViewOutlinedIcon />,
};

export const checkBoxOn = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M18 .5c.966 0 1.841.392 2.475 1.025A3.489 3.489 0 0 1 21.5 4v14c0 .966-.392 1.841-1.025 2.475A3.489 3.489 0 0 1 18 21.5H4a3.489 3.489 0 0 1-2.475-1.025A3.489 3.489 0 0 1 .5 18V4c0-.966.392-1.841 1.025-2.475A3.489 3.489 0 0 1 4 .5z"
        stroke="#2C61E4"
        fill="#2A67FF"
      />
      <path
        d="M10.634 14.44a.978.978 0 0 1-1.386 0l-2.961-2.97a.984.984 0 0 1 0-1.388.978.978 0 0 1 1.385 0l2.268 2.275 4.388-4.4a.978.978 0 0 1 1.385 0 .984.984 0 0 1 0 1.39l-5.08 5.094z"
        fill="#FFF"
      />
    </g>
  </svg>
);

export const checkBoxOff = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 .5c.966 0 1.841.392 2.475 1.025A3.489 3.489 0 0 1 21.5 4v14c0 .966-.392 1.841-1.025 2.475A3.489 3.489 0 0 1 18 21.5H4a3.489 3.489 0 0 1-2.475-1.025A3.489 3.489 0 0 1 .5 18V4c0-.966.392-1.841 1.025-2.475A3.489 3.489 0 0 1 4 .5z"
      fill="#FFF"
      stroke="#848B9E"
      fillRule="evenodd"
      strokeOpacity=".5"
    />
  </svg>
);

export const currencyImages = {
  SATS: bitCoinSymbol,
  USDT: usdtIcon,
  USDC: usdcSymbol,
  GGC: ggcIcon,
  USD: usdIcon,
  XAUT: xautIcon,
  BTC: bitCoinSymbol,
};

export const lightningIcons = {
  SATS: fill,
  USDT: usdtLightningIcon,
  USDC: usdcLightningIcon,
};
